// extracted by mini-css-extract-plugin
module.exports = {"splitPane":"AppPage_splitPane__3oqSX","content":"AppPage_content__--2Lh","panel":"AppPage_panel__n4jIn"};